import { render, staticRenderFns } from "./MetadataGenerator.vue?vue&type=template&id=1ef9894d&"
import script from "./MetadataGenerator.vue?vue&type=script&lang=js&"
export * from "./MetadataGenerator.vue?vue&type=script&lang=js&"
import style0 from "./MetadataGenerator.vue?vue&type=style&index=0&id=1ef9894d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports